<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="rankList"
    item-key="userId"
    :items-per-page="-1"
  >
    <template v-slot:top>
      <div class="pb-4">イベントランキング</div>
    </template>  
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        dialog: false,
        reason: '11',
        db: null,
        selected: [],
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'userId',
          },
          { text: 'ランク', value: 'rank' },
          { text: 'ユーザー名', value: 'userName' },
          { text: 'ポイント', value: 'acquiredPoint' },
        ],
        rankList: []
      }
    },
    methods: {
      getRankList () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'rank')
          .withConverter(this.rankConverter),
          this.$fb.where('event_id', '==', 'QwX6BYRujZ1hrUwdKXen'),
          this.$fb.orderBy('rank'),
          this.$fb.limit(1000)))
          .then(rankSnap => {
            this.rankList = []
            rankSnap.forEach(rankDoc => {
              let rank = rankDoc.data()
              if (rank.userId.length === 5 || rank.userId.substring(0, 2) === '0x') return
              rank.point = parseFloat(rank.acquiredPoint - rank.usedPoint).toFixed(1)
              const userPromise = this.$fb.getDoc(this.$fb.doc(
                this.$fb.firestore,
                'users',
                rank.userId)
                .withConverter(this.userConverter))
              const promiseArray = [
                userPromise,
              ]
              Promise.all(promiseArray).then(resultArray => {
                const userDoc = resultArray[0]
                rank.userName = userDoc.data()?.nickname
                this.rankList.push(rank)
              })
            })
          }).catch(error => {
            console.error(error)
            this.rankList = []
          })
      },
    },
    created () {
      this.getRankList()
    }
  }
</script>